<template>
  <div data-app class="comment-box">
    <v-overlay v-if="addComment" />

    <div class="comment-box-header">
      <h4>{{ $t("comment.title") }}</h4>
      <div class="comment-box-button" @click="addComment = !addComment">
        <BaseIcon
          class="inline-block"
          icon="message"
          size="25px"
          hover
          :multiplatform="getAppName() === 'huygens'"
        />
      </div>
    </div>

    <!-- //Comments -->
    <template v-if="!addComment && comments.length > 0">
      <div
        v-for="(comment, i) in comments"
        :key="`comment_${i}`"
        class="comment-box-entry"
      >
        <span :class="`comment-box-date ${getAppName()}`">
          {{ formatDate(comment.inserted_at) }}
        </span>
        <h4>{{ comment.author }}</h4>
        <div :class="`comment-box-divider ${getAppName()}`" />
        <p>{{ comment.comment }}</p>
      </div>
    </template>

    <template v-if="comments.length < 1">
      <p>{{ $t("comment.no-comments") }}</p>
    </template>

    <!-- Add comment-->
    <v-bottom-sheet
      v-model="addComment"
      persistent
      attach=".comment-box"
      hide-overlay
    >
      <v-sheet class="comment-drawer" height="50vh">
        <div class="comment-drawer-header">
          <div class="comment-drawer-header-spacer" />
          <div class="comment-drawer-header-title">
            <h2>{{ $t("comment.comment") }}</h2>
          </div>

          <div class="comment-drawer-header-button mr-12">
            <div @click="addComment = !addComment">
              <BaseIcon icon="close" hover />
            </div>
          </div>
        </div>

        <div class="comment-drawer-wrapper">
          <div class="comment-drawer-input">
            <BaseInput
              :value.sync="author"
              outlined
              dense
              :placeholder="$t('comment.author-placeholder')"
            />
            <BaseInput
              :value.sync="comment"
              outlined
              :text-area="true"
              :placeholder="$t('comment.comment-placeholder')"
            />
            <div class="w-100 px-2 justify-center">
              <BaseButton class="mt-4" @click="() => onAddComment()">
                <span v-if="loading">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </span>
                <span v-else>{{ $t("comment.comment-button") }}</span>
              </BaseButton>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import moment from "moment";
import { appIdentifier } from "@/utils/appIdentifier.js";

export default {
  name: "CommentBox",
  props: {
    articleId: {
      type: Number,
      required: true
    },
    comments: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      addComment: false,
      author: "",
      comment: "",
      loading: false
    };
  },
  methods: {
    getAppName() {
      return appIdentifier();
    },
    onAddComment() {
      this.loading = true;
      this.$store
        .dispatch(this.$actions.ADD_COMMENT, {
          article_id: this.articleId,
          author: this.author,
          comment: this.comment
        })
        .then(() => {
          this.addComment = false;
          this.author = "";
          this.comment = "";
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(date) {
      return moment(date)
        .utc(true)
        .locale(this.$store.state.locale)
        .format("D MMMM YYYY HH:mm");
    }
  }
};
</script>

<style lang="scss" scoped>
.comment-box {
  width: 80%;

  &-button {
    display: inline;
    margin-left: 20px;
    height: auto;
  }

  &-divider {
    margin-top: 3px;
    border-bottom: 1px solid white;

    &.canals5D {
      border-bottom: 1px solid rgba($secondary-canals5D, 0.4);
    }
  }

  &-header {
    height: 65px;

    h4 {
      display: inline-block;
      padding-botttom: 30px;
      vertical-align: top;
    }

    span {
      cursor: pointer;
    }
  }

  &-more {
    height: 150px;
    width: 100%;
    text-align: center;

    &:hover {
      cursor: pointer;
    }
  }

  &-entry {
    direction: ltr;

    p {
      margin: 20px 0 40px;
    }
  }

  &-date {
    font-family: "DINNextLTPro-Medium";
    font-size: 1.5rem;
    font-style: italic;
    float: right;
    color: #b7cac7;
    text-transform: lowercase;

    &.canals5D {
      color: rgba(white, 0.4);
    }

    &.huygens {
      color: #bebb9b;

      font-family: Hurme Geometric Sans 1;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      /* 128.571% */
    }
  }
}

.comment-drawer {
  background-color: var(--v-brand-base);

  &-wrapper {
    display: flex;
    justify-content: center;
    height: 100%;
    width: 70%;
    margin: 0 auto;
  }

  &-input {
    width: 60%;
  }

  &-header {
    display: flex;
    align-items: center;
    text-align: center;
    height: 80px;

    &-spacer {
      width: 68px;
    }

    &-title {
      flex: 8;
    }
  }
}
</style>
